var _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompetitive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.28,123.92a14.77,14.77,0,0,0,8.8-13.66c0-8.15-6.14-14.79-13.79-14.83s-13.87,6.55-13.9,14.7a14.75,14.75,0,0,0,8.82,13.79c-21.3,3.21-20.33,26.36-20.33,26.36l50.37.23S461.4,127.11,440.28,123.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 349.99,
    cy: 181.45,
    r: 12.47,
    transform: "translate(-13.32 334.5) rotate(-50.25)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.4,167.8a3.23,3.23,0,1,1-1.93-4.14A3.23,3.23,0,0,1,358.4,167.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.79,285.16h45.64a7.62,7.62,0,0,1,7.62,7.62v1.51a0,0,0,0,1,0,0H280.17a0,0,0,0,1,0,0v-1.51A7.62,7.62,0,0,1,287.79,285.16Z",
    transform: "translate(117.75 -88.73) rotate(19.99)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.19,263.27s-5.78,4.16-10.74,4.5a13.1,13.1,0,0,0-4.27.93,4.18,4.18,0,0,0-2.73,3.55c-.49,3.41,5.61,5.5,5.61,5.5l23.92,8.7,6.07-16.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.91,294.07s3.16,1.51,5-1.19a4.74,4.74,0,0,0,.16-5.07,15,15,0,0,0-2.7-3.33c-3.59-3.44-5.35-10.34-5.35-10.34l-17.85-6.5-6.07,16.69",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.69 258.03 303.15 263.26 333.13 274.17 337.8 271.17 301.69 258.03",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.94,
    y: 220.81,
    width: 29.27,
    height: 6.04,
    rx: 2.52,
    transform: "matrix(0.94, 0.34, -0.34, 0.94, 96.68, -100.89)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.9,
    y: 217.32,
    width: 24.71,
    height: 3.79,
    rx: 1.58,
    transform: "translate(95.2 -101.74) rotate(19.99)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.96,
    y: 212.07,
    width: 20.97,
    height: 2.26,
    rx: 0.94,
    transform: "translate(93.27 -102.85) rotate(19.99)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.57,223.77S315.67,250,301.69,258l18.1,6.59,13.8-37.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.05,229.4s-8.81,26.65-3.25,41.77l-18.57-6.75L333,226.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.21,185.6c-2.5-5-7.21-2.33-9.1-1.41s-4.56-.41-5.13-3.52c-.48-2.56-1.9-3.11-2.52-3.26s-2-.78-4,.88c-2.44,2-5.34,1.32-6.2-.6s-2.76-7-7.87-4.76c0,0,4.25,12.78,1.72,23.51s-4.4,15.5-6.53,18l8.09,2.94.51.19,8.09,2.94c-.05-3.26,1.58-8.11,6.53-18S368.21,185.6,368.21,185.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.7,293.3c-.05.14-9.74-3.26-21.63-7.59s-21.51-7.94-21.46-8.08,9.73,3.26,21.63,7.59S333.75,293.17,333.7,293.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.31,274.23c-.05.14-6.84-2.21-15.16-5.24s-15-5.59-15-5.73,6.84,2.21,15.17,5.24S333.36,274.1,333.31,274.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.8,271.17c0,.14-8.17-2.7-18.14-6.32s-18-6.68-18-6.82,8.17,2.7,18.14,6.33S337.85,271,337.8,271.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.34,230.6c0,.13-4.92-1.51-10.89-3.68s-10.75-4-10.71-4.18,4.93,1.52,10.89,3.69S344.39,230.46,344.34,230.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.41,224.92c-.05.14-4.93-1.51-10.89-3.68s-10.76-4-10.71-4.17,4.92,1.51,10.89,3.68S346.45,224.79,346.41,224.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.71,221c0,.13-4.48-1.35-9.9-3.32s-9.76-3.68-9.71-3.81a102.18,102.18,0,0,1,9.89,3.32A103,103,0,0,1,346.71,221Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,217.6a89.23,89.23,0,0,1-9.09-3,89.6,89.6,0,0,1-8.92-3.52,87.21,87.21,0,0,1,9.09,3A86.79,86.79,0,0,1,347,217.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.88,215.3a86.9,86.9,0,0,1-9.1-3,90.84,90.84,0,0,1-8.92-3.52,86.9,86.9,0,0,1,9.1,3A89.6,89.6,0,0,1,347.88,215.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.37,172.93s.13-.09.4-.21l.51-.21.74-.17a8.45,8.45,0,0,1,1-.08,4.69,4.69,0,0,1,1.12.19,5,5,0,0,1,2.28,1.56,11.26,11.26,0,0,1,1.73,2.83,4.78,4.78,0,0,0,.87,1.51,3,3,0,0,0,1.56.83,4.45,4.45,0,0,0,3.67-1,6,6,0,0,1,2-1.14,3.18,3.18,0,0,1,2.4.17,2.75,2.75,0,0,1,1.06.5,3.45,3.45,0,0,1,.82.89,5.75,5.75,0,0,1,.79,2.14,4.48,4.48,0,0,0,2.15,3.15,3,3,0,0,0,1.74.37,4.83,4.83,0,0,0,1.63-.6,11.64,11.64,0,0,1,3.14-1.06,5.14,5.14,0,0,1,2.75.27,4.61,4.61,0,0,1,1,.58,6.19,6.19,0,0,1,.68.67l.45.61.26.48c.13.27.2.41.18.42s-.11-.12-.27-.36l-.3-.46-.47-.56a8.5,8.5,0,0,0-.68-.6,4,4,0,0,0-.94-.51,4.85,4.85,0,0,0-2.58-.18,11.54,11.54,0,0,0-3,1.09l-.81.4a2.85,2.85,0,0,1-1,.26,3.44,3.44,0,0,1-2-.4,4.94,4.94,0,0,1-2.43-3.47c-.25-1.36-.87-2.8-2.4-3.17a2.72,2.72,0,0,0-2-.13,5.3,5.3,0,0,0-1.81,1,4.88,4.88,0,0,1-4.09,1.09,3.43,3.43,0,0,1-1.79-1,3.26,3.26,0,0,1-.57-.82l-.36-.83a11,11,0,0,0-1.62-2.77,4.82,4.82,0,0,0-2.09-1.52,4.61,4.61,0,0,0-1-.22,6.58,6.58,0,0,0-.91,0l-.72.12-.52.16A1.8,1.8,0,0,1,333.37,172.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.37,217.23a35.64,35.64,0,0,1,8.66-3.76l1.79-8.57,14.48-.26,2.08,8.51a35.32,35.32,0,0,1,8.79,3.45l7.32-4.79,10.42,10.06-4.53,7.48a35.64,35.64,0,0,1,3.76,8.66l8.57,1.79.26,14.48-8.51,2.08a35.5,35.5,0,0,1-3.46,8.79l4.8,7.32-10.06,10.42-7.48-4.54a35.67,35.67,0,0,1-8.66,3.77l-1.79,8.57-14.48.25-2.08-8.5a35.35,35.35,0,0,1-8.79-3.46l-7.32,4.8-10.42-10.06,4.54-7.48a35.57,35.57,0,0,1-3.77-8.67l-8.57-1.78-.25-14.48,8.5-2.09a35.43,35.43,0,0,1,3.46-8.78l-4.8-7.32,10.06-10.42,7.48,4.53Zm7.72,19.3a15.54,15.54,0,1,0,22-.39A15.54,15.54,0,0,0,156.09,236.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.94,371.64a24.54,24.54,0,0,1,6-2.6l1.23-5.91,10-.17,1.44,5.86a24.88,24.88,0,0,1,6.06,2.38l5.05-3.3,7.18,6.93L83.74,380a24.51,24.51,0,0,1,2.59,6l5.91,1.23.18,10-5.87,1.44a24.33,24.33,0,0,1-2.38,6.06l3.31,5.05-6.94,7.19-5.16-3.13a24.61,24.61,0,0,1-6,2.59l-1.23,5.91-10,.18-1.44-5.87a24.48,24.48,0,0,1-6.06-2.38l-5,3.31-7.18-6.94,3.13-5.16a24.64,24.64,0,0,1-2.6-6l-5.91-1.23-.18-10,5.87-1.44a24.48,24.48,0,0,1,2.38-6.06l-3.31-5,6.94-7.19,5.16,3.13Zm5.33,13.3a10.72,10.72,0,1,0,15.15-.26A10.73,10.73,0,0,0,55.27,384.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7,151.26a14.69,14.69,0,0,1,3.64-1.59l.75-3.6,6.09-.11.88,3.58A14.91,14.91,0,0,1,59.75,151l3.08-2,4.39,4.24-1.91,3.14A15.28,15.28,0,0,1,66.89,160l3.61.75.1,6.09-3.57.88a14.94,14.94,0,0,1-1.46,3.69l2,3.08-4.23,4.39L60.21,177a15.21,15.21,0,0,1-3.64,1.58l-.75,3.61-6.09.1-.88-3.57a15,15,0,0,1-3.7-1.46l-3.08,2L37.69,175l1.91-3.15A14.45,14.45,0,0,1,38,168.23l-3.61-.75-.11-6.1,3.58-.87a15,15,0,0,1,1.45-3.7l-2-3.08,4.23-4.38,3.15,1.91Zm3.24,8.11a6.54,6.54,0,1,0,9.25-.16A6.55,6.55,0,0,0,47.94,159.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.57,46A29.7,29.7,0,1,1,207.91,21,29.67,29.67,0,0,1,241.57,46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.58,47a22.64,22.64,0,1,1-25.65-19.1A22.61,22.61,0,0,1,234.58,47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.47,46.32a12.85,12.85,0,0,1-1-2.6,24,24,0,0,0-3.59-6.49,23.26,23.26,0,0,0-3.55-3.64,22.88,22.88,0,0,0-4.95-3.06,22.21,22.21,0,0,0-6.15-1.77,22.37,22.37,0,0,0-3.39-.2,24.4,24.4,0,0,0-3.48.34,23.61,23.61,0,0,0-3.38.88,21.63,21.63,0,0,0-3.11,1.35,22.37,22.37,0,0,0-5.17,3.78,22.72,22.72,0,0,0-3.59,4.57,23.34,23.34,0,0,0-2.08,4.64,24.08,24.08,0,0,0-1.13,7.33,12.83,12.83,0,0,1,0,2.79,6.74,6.74,0,0,1-.64-2.75,20.86,20.86,0,0,1,.62-7.71,23.41,23.41,0,0,1,2-5,23.14,23.14,0,0,1,3.71-5,23,23,0,0,1,8.85-5.63,25.6,25.6,0,0,1,3.64-1,25.28,25.28,0,0,1,3.75-.35,22.14,22.14,0,0,1,3.66.24,21.25,21.25,0,0,1,3.44.78,22.85,22.85,0,0,1,3.15,1.22,22.62,22.62,0,0,1,8.81,7.42,20.73,20.73,0,0,1,3.24,7A6.58,6.58,0,0,1,234.47,46.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.65,63.27l.63,3.9-3.48.55-.61-3.79a16.61,16.61,0,0,1-9.1-1.39L205.32,58a14.2,14.2,0,0,0,7.14,1.39l-.93-5.81c-4-.32-8.52-.91-9.32-5.88-.59-3.69,1.58-7.28,7-8.78l-.61-3.86,3.47-.56.61,3.79a15.94,15.94,0,0,1,7.4,1L219,43.82a14.44,14.44,0,0,0-5.61-1l1,5.91c4,.28,8.45.89,9.24,5.79C224.14,58.19,222,61.74,216.65,63.27Zm-5.93-14.81-.8-4.93c-1.77.71-2.34,1.84-2.16,3S209.11,48.22,210.72,48.46ZM218,55.89c-.2-1.22-1.31-1.72-2.89-2l.77,4.79C217.59,58,218.21,57,218,55.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.27,456.84a23.9,23.9,0,1,1-27.08-20.16A23.86,23.86,0,0,1,338.27,456.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.64,457.65A18.21,18.21,0,1,1,312,442.29,18.19,18.19,0,0,1,332.64,457.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.55,457.09a11.5,11.5,0,0,1-.79-2.1,19.2,19.2,0,0,0-2.88-5.22,18,18,0,0,0-6.84-5.39,16.26,16.26,0,0,0-2.37-.87,16.63,16.63,0,0,0-2.58-.55,16.36,16.36,0,0,0-2.72-.16,19.08,19.08,0,0,0-2.8.27,18.39,18.39,0,0,0-2.72.71,17,17,0,0,0-2.5,1.08,18.06,18.06,0,0,0-2.24,1.41,16.92,16.92,0,0,0-1.92,1.64,18.12,18.12,0,0,0-4.57,7.41,19.06,19.06,0,0,0-.9,5.89,11.53,11.53,0,0,1,0,2.24,5.21,5.21,0,0,1-.53-2.21,17.05,17.05,0,0,1,.5-6.2,18.6,18.6,0,0,1,6.64-9.84,18.4,18.4,0,0,1,2.39-1.54,18.6,18.6,0,0,1,2.69-1.19,19.24,19.24,0,0,1,2.94-.77,20.71,20.71,0,0,1,3-.29,17.78,17.78,0,0,1,2.94.2,17.46,17.46,0,0,1,2.77.62,18.35,18.35,0,0,1,2.54,1,18.9,18.9,0,0,1,4.18,2.74,18.62,18.62,0,0,1,2.91,3.22,16.89,16.89,0,0,1,2.6,5.65A5.21,5.21,0,0,1,332.55,457.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.22,470.72l.5,3.14-2.79.44-.49-3a13.42,13.42,0,0,1-7.32-1.13l1-3.65a11.41,11.41,0,0,0,5.74,1.11l-.75-4.67c-3.22-.26-6.85-.74-7.49-4.73-.48-3,1.27-5.86,5.6-7.07l-.49-3.1,2.79-.45.49,3.05a12.8,12.8,0,0,1,5.95.79l-.85,3.67a11.53,11.53,0,0,0-4.51-.77l.76,4.75c3.22.23,6.8.72,7.43,4.66C324.25,466.63,322.53,469.49,318.22,470.72Zm-4.77-11.91-.64-4c-1.43.57-1.89,1.48-1.74,2.4S312.15,458.62,313.45,458.81Zm5.89,6c-.16-1-1.06-1.38-2.33-1.61l.62,3.86C319,466.5,319.48,465.68,319.34,464.78Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.26,259.44s0-1-.1-2.87c0-.95-.06-2.13-.1-3.53s-.07-3-.25-4.88-.3-3.9-.48-6.18-.59-4.74-.92-7.42a186.51,186.51,0,0,0-3.59-18.31c-.38-1.71-.95-3.43-1.43-5.22l-.78-2.7-.39-1.38-.46-1.38-1.93-5.67c-.31-1-.69-1.93-1.08-2.9s-.77-2-1.16-2.95a169.84,169.84,0,0,0-12.3-24.9,178.55,178.55,0,0,0-44.86-50.21,176.15,176.15,0,0,0-74.35-33l-5.47-1-5.56-.71c-3.71-.56-7.49-.72-11.29-1-1.9-.17-3.82-.13-5.74-.2l-2.88-.07c-1,0-1.93-.06-2.9,0-3.87.12-7.77.1-11.69.49a176.4,176.4,0,0,0-23.66,3.31c-3.94.91-7.92,1.76-11.84,3-4,1-7.83,2.45-11.77,3.76a176.95,176.95,0,0,0-44.72,24,192.72,192.72,0,0,0-19.92,17.16A190.53,190.53,0,0,0,111.2,155l-3.93,5.53-3.69,5.73c-1.27,1.89-2.33,3.92-3.49,5.88l-1.71,3-1.58,3-1.57,3.07c-.53,1-1,2.05-1.5,3.11l-2.85,6.31q-1.27,3.22-2.56,6.46l-.64,1.62-.56,1.65L86,203.69,84.89,207l-1,3.37-1,3.37-.47,1.7-.4,1.71q-.78,3.43-1.58,6.87-.61,3.48-1.24,7a176.3,176.3,0,0,0,0,56.83c.42,2.33.83,4.65,1.25,7s1,4.59,1.57,6.87l.4,1.72c.14.57.31,1.13.47,1.69l1,3.38,1,3.37L86,315.15l1.12,3.31.56,1.65.64,1.62,2.55,6.47,2.86,6.31.71,1.57.79,1.54,1.57,3.06,1.58,3.06,1.71,3c1.16,2,2.21,4,3.49,5.88s2.46,3.82,3.68,5.73l3.94,5.53a189.66,189.66,0,0,0,17.44,20.36,193.77,193.77,0,0,0,19.92,17.16,185.33,185.33,0,0,0,21.76,13.78,187.35,187.35,0,0,0,23,10.27c3.94,1.31,7.81,2.73,11.78,3.76,3.91,1.21,7.9,2.05,11.83,3a176.74,176.74,0,0,0,23.67,3.3c3.91.39,7.82.37,11.69.49,1,.05,1.93,0,2.9,0l2.88-.07c1.92-.07,3.84,0,5.74-.2,3.8-.32,7.58-.48,11.29-1l5.56-.71,5.47-1a176.15,176.15,0,0,0,74.35-33,178.75,178.75,0,0,0,44.86-50.22,171.16,171.16,0,0,0,12.29-24.89l1.16-2.95c.39-1,.77-1.93,1.08-2.91l1.93-5.66c.15-.47.31-.93.46-1.38s.27-.92.4-1.38c.26-.91.51-1.82.77-2.71.48-1.78,1.05-3.5,1.43-5.22a186.36,186.36,0,0,0,3.59-18.3c.33-2.68.69-5.15.92-7.42s.34-4.34.48-6.18.22-3.47.25-4.88.07-2.58.1-3.53c.06-1.89.1-2.86.1-2.86s0,1,0,2.86c0,.95-.05,2.13-.08,3.53s-.05,3-.22,4.88-.29,3.91-.46,6.19-.58,4.74-.9,7.43A182.47,182.47,0,0,1,425,302.66c-.38,1.72-.94,3.44-1.43,5.23-.25.89-.5,1.8-.76,2.71l-.39,1.39c-.16.45-.31.91-.47,1.37L420.06,319c-.31,1-.69,1.94-1.08,2.91s-.77,2-1.16,3a170.44,170.44,0,0,1-12.27,24.95,178.66,178.66,0,0,1-44.89,50.36,176.59,176.59,0,0,1-74.49,33.15l-5.48,1-5.57.72c-3.72.56-7.52.72-11.33,1-1.9.17-3.82.13-5.75.21l-2.89.08c-1,0-1.93.05-2.9,0-3.88-.13-7.8-.11-11.72-.49a177.38,177.38,0,0,1-23.73-3.3c-4-.92-7.94-1.77-11.87-3-4-1-7.87-2.45-11.81-3.77a177.15,177.15,0,0,1-44.86-24.1,194.92,194.92,0,0,1-20-17.2,191.92,191.92,0,0,1-17.49-20.42c-1.32-1.84-2.63-3.69-4-5.54l-3.7-5.75c-1.27-1.89-2.33-3.93-3.5-5.9l-1.72-3-1.58-3.07-1.57-3.07L94,336.3l-.72-1.57-2.86-6.33c-.85-2.16-1.71-4.32-2.56-6.49l-.64-1.62-.56-1.66-1.13-3.32L84.38,312l-1-3.39-1-3.38c-.16-.57-.33-1.13-.47-1.7l-.4-1.72c-.53-2.3-1-4.6-1.58-6.9s-.83-4.65-1.25-7a176.53,176.53,0,0,1,0-57c.41-2.34.83-4.66,1.25-7s1-4.6,1.58-6.89l.39-1.72.48-1.7,1-3.39,1-3.38,1.12-3.32,1.13-3.32.56-1.66.64-1.62c.85-2.17,1.71-4.33,2.56-6.49s1.91-4.22,2.86-6.32c.46-1.07,1-2.1,1.51-3.12l1.58-3.07,1.58-3.07,1.71-3c1.17-2,2.23-4,3.51-5.9l3.69-5.74,4-5.55a190.7,190.7,0,0,1,17.49-20.4,196,196,0,0,1,20-17.21A177.54,177.54,0,0,1,193.12,93c3.94-1.31,7.83-2.73,11.8-3.77,3.93-1.2,7.93-2,11.87-3A177.64,177.64,0,0,1,240.52,83c3.92-.38,7.84-.36,11.72-.48,1,0,1.94,0,2.9,0l2.9.07c1.92.08,3.84,0,5.75.21,3.8.32,7.6.48,11.32,1l5.57.72,5.48,1a176.24,176.24,0,0,1,74.49,33.13A178.79,178.79,0,0,1,405.54,169a170.63,170.63,0,0,1,12.28,25c.39,1,.77,2,1.16,2.95s.77,1.93,1.07,2.91q1,2.91,1.92,5.68c.16.46.31.92.46,1.38l.39,1.38c.26.92.52,1.82.77,2.71.48,1.8,1.05,3.52,1.43,5.23a182.62,182.62,0,0,1,3.54,18.34c.32,2.68.68,5.16.9,7.43s.32,4.34.46,6.19.2,3.47.22,4.88.06,2.58.08,3.53C430.25,258.47,430.26,259.44,430.26,259.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.57,303.52c3.7.2,6.48-4.1,5.76-7.74s-3.92-6.34-7.35-7.76-7.17-1.85-10.76-2.77a40.71,40.71,0,0,1-25.36-19.78,68.35,68.35,0,0,1-4.68-11.54c-5.05-21.27-12-51.68-13.75-63.53-4.42-30.59-12.22-64.19-55.94-61.06,0,0-29.07,5.47-40.22,26.32-9.81,18.33-4.15,73.61-5.45,113.43l9.53,5.74,1.48.09a37.74,37.74,0,0,0,5.26,11.42c8.7,12.41,20.55,22.38,33.39,30.44,26,16.29,57,25.18,87.51,22.12,6.44-.65,13-1.86,18.6-5s10.28-8.65,11.13-15.06S360.8,305.26,354.57,303.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.67,140.74l2.74-2.61L269,150a8.25,8.25,0,0,1,7.79,8l-.26,96.3c0,6.53-1.27,12.19-5.21,17.39l-4.15,5.48c-9.47,12.5-28.94,11.47-36.43-2.3a10.15,10.15,0,0,1-1-2.49,17.52,17.52,0,0,1-.44-2.15c-.88-7.75-.93-14.47-.93-14.47-.53-8.5-.7-12-.71-11.91s-18.1-2.09-23-25.32c-2.44-11.56-2-27.46-1.29-43.11C204.24,153.8,219.26,140.72,236.67,140.74Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.73,191.31a3,3,0,0,0,3.05,2.88,2.87,2.87,0,0,0,3-2.86,3,3,0,0,0-3.05-2.89A2.88,2.88,0,0,0,242.73,191.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.18,191.31a3,3,0,0,0,3,2.88,2.88,2.88,0,0,0,3-2.86,3,3,0,0,0-3.05-2.89A2.87,2.87,0,0,0,212.18,191.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.39,181.64c.39.38,2.58-1.42,5.81-1.58s5.69,1.35,6,.93c.16-.18-.25-.87-1.32-1.57a8.26,8.26,0,0,0-4.84-1.23,7.91,7.91,0,0,0-4.61,1.75C206.5,180.75,206.2,181.48,206.39,181.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.19,182c.43.33,2.43-1.69,5.63-2.17s5.79.75,6.08.31c.14-.2-.34-.84-1.48-1.43a8.27,8.27,0,0,0-4.94-.73,7.94,7.94,0,0,0-4.4,2.21C239.21,181.08,239,181.83,239.19,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.9,205.51c0-.19-2-.43-5.3-.68-.83-.05-1.62-.17-1.79-.73a4.24,4.24,0,0,1,.43-2.47l2.13-6.41c2.94-9.12,5-16.6,4.66-16.72s-3.05,7.18-6,16.3c-.7,2.25-1.38,4.39-2,6.44a4.8,4.8,0,0,0-.26,3.27,2.05,2.05,0,0,0,1.42,1.13,5.64,5.64,0,0,0,1.41.13C225.86,205.78,227.9,205.69,227.9,205.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.58,243.88a59.73,59.73,0,0,0,31-9.95s-7.08,16.62-30.63,15.6Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.66,213.23a5.82,5.82,0,0,1,5.11-2.42,5.31,5.31,0,0,1,3.77,1.78,3.37,3.37,0,0,1,.45,3.84,3.91,3.91,0,0,1-4.18,1.29,12.17,12.17,0,0,1-4.26-2.26,3.66,3.66,0,0,1-1-.91,1.09,1.09,0,0,1-.06-1.21",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.53,207.27c-.53,0-.36,3.5-3.24,6.14s-6.63,2.45-6.64,2.94c0,.22.87.64,2.45.6a8.7,8.7,0,0,0,5.55-2.25,7.6,7.6,0,0,0,2.49-5.14C238.2,208.09,237.76,207.24,237.53,207.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.1,169.38c.45.82,3.58-.09,7.4-.21s7,.44,7.4-.42c.16-.41-.49-1.14-1.85-1.8a12.87,12.87,0,0,0-11.27.48C236.49,168.19,235.9,169,236.1,169.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,167.75c.61.71,2.8-.16,5.47-.34s5,.25,5.46-.54c.21-.39-.19-1.11-1.21-1.75a7.94,7.94,0,0,0-8.8.71C206.86,166.64,206.58,167.41,206.85,167.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.16,199.13s-16.55,5.15-25.92-35.71c-3.21-14-16.16-25.29-16.16-25.29l5.25-1.58s32.65,9.2,33.2,9.61,8.24,16.89,8.24,16.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.08,197.61c-.08-1.75,1.73-6,3.44-6.32,4.56-.95,12.87-1,13.54,10.69.9,16-15.31,13.58-15.37,13.12S272.37,203.63,272.08,197.61Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.23,208.78c.06-.06.29.18.77.37a2.8,2.8,0,0,0,2.08-.08c1.65-.71,2.92-3.47,2.83-6.35a9.14,9.14,0,0,0-1-3.94,3.22,3.22,0,0,0-2.21-2,1.42,1.42,0,0,0-1.6.86c-.19.46-.07.77-.15.8s-.36-.25-.27-.91a1.76,1.76,0,0,1,.57-1,2.13,2.13,0,0,1,1.52-.49,3.9,3.9,0,0,1,3,2.31,9.41,9.41,0,0,1,1.22,4.39c.08,3.22-1.4,6.33-3.67,7.13a3,3,0,0,1-2.57-.28C278.28,209.16,278.17,208.81,278.23,208.78Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.65,257.94a40.78,40.78,0,0,1-.35-5.58,86.88,86.88,0,0,1,1.55-15.16c.57-3.17,1.19-6.64,1.86-10.36a97.24,97.24,0,0,0,1.43-12,48.72,48.72,0,0,0-1-13.22,34.11,34.11,0,0,0-2.25-6.63,31.75,31.75,0,0,0-3.78-6.13,74.07,74.07,0,0,0-10-10.13c-3.5-3-6.85-6-9.83-9.05a124.21,124.21,0,0,1-14.36-17.47,120.8,120.8,0,0,1-7.78-13.11c-.82-1.6-1.42-2.86-1.81-3.73-.19-.42-.34-.74-.44-1a1.89,1.89,0,0,1-.14-.34,2,2,0,0,1,.18.32q.18.34.48,1c.41.85,1,2.1,1.88,3.69a128.25,128.25,0,0,0,7.89,13,125.66,125.66,0,0,0,14.39,17.35c3,3,6.32,6,9.82,9a73.81,73.81,0,0,1,10.12,10.18,31.86,31.86,0,0,1,3.83,6.22,34.11,34.11,0,0,1,2.27,6.72,49.15,49.15,0,0,1,.95,13.33,98.87,98.87,0,0,1-1.48,12c-.69,3.72-1.33,7.19-1.91,10.35a90.26,90.26,0,0,0-1.69,15.11c0,1.8,0,3.2.11,4.14l.07,1.08A1.63,1.63,0,0,1,289.65,257.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.79,259.45a39,39,0,0,1-.35-5.58A86.89,86.89,0,0,1,296,238.7c.57-3.17,1.19-6.64,1.86-10.36a99,99,0,0,0,1.43-12,48.72,48.72,0,0,0-1-13.22,34.11,34.11,0,0,0-2.25-6.63,31.75,31.75,0,0,0-3.78-6.13,74.65,74.65,0,0,0-10.05-10.13c-3.5-3-6.85-6-9.83-9.05a123.65,123.65,0,0,1-14.36-17.47,120.8,120.8,0,0,1-7.78-13.11c-.82-1.6-1.42-2.86-1.81-3.73l-.45-1a2.25,2.25,0,0,1-.13-.34l.18.32c.11.24.27.55.48,1,.41.86,1,2.1,1.88,3.69a128.25,128.25,0,0,0,7.89,13,125.65,125.65,0,0,0,14.38,17.35c3,3,6.32,6,9.83,9a73.81,73.81,0,0,1,10.12,10.18,32.35,32.35,0,0,1,3.83,6.22,34.11,34.11,0,0,1,2.27,6.72,49.58,49.58,0,0,1,.95,13.33,98.87,98.87,0,0,1-1.48,12c-.69,3.72-1.33,7.19-1.91,10.35a90.26,90.26,0,0,0-1.69,15.12c0,1.79,0,3.19.1,4.13,0,.46.06.82.07,1.08A1.49,1.49,0,0,1,294.79,259.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.51,282.46c-6.89,4.4-14.59,11.53-18.24,18.85-6.6,13.26-52.89,48.88-54.7,57.51-4.16,36.85,36.6,36.37,53.1,16.66,8.54-10.2,27.36-48.42,27.36-48.42l-7.52-44.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.07,339.44s30.6-49.26,36.6-56.15c9.19-10.54,25.16-14.76,25.16-14.76l3.44,64.59c.21-.89-31.62,39.79-31.62,39.79S131.92,350.82,128.07,339.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.08,289.6l-33.27,63.53a13.84,13.84,0,0,0,4.58,18.06l.14.09c12.76,8.07,29.67.19,32.48-14.64l11.71-59.37Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.45 234.32 158.1 285.3 162.96 287.34 183.66 235.79 179.45 234.32",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 190.04,
    cy: 211.83,
    rx: 25.81,
    ry: 23.89,
    transform: "translate(-36.49 384.1) rotate(-85.35)",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.94,211.87a6.1,6.1,0,0,1-.24-1.63c0-.27,0-.57-.07-.89s-.11-.68-.18-1.07a20.42,20.42,0,0,0-.52-2.62,26,26,0,0,0-2.64-6.68,24.44,24.44,0,0,0-5.92-7.07,22.16,22.16,0,0,0-9.74-4.6,21.56,21.56,0,0,0-2.92-.34c-.5,0-1-.07-1.51-.06l-1.53.1c-.25,0-.51,0-.77.05l-.77.13c-.51.1-1,.17-1.55.28a23.45,23.45,0,0,0-3.08,1,23,23,0,0,0-3,1.43c-.49.29-1,.62-1.44.93a10.8,10.8,0,0,0-1.4,1,25.78,25.78,0,0,0-2.64,2.4,27,27,0,0,0-2.28,2.88,25.15,25.15,0,0,0-3.37,6.83,29.09,29.09,0,0,0-1.28,7.83,28.69,28.69,0,0,0,1.08,7.83,24.64,24.64,0,0,0,3.19,6.84,21.77,21.77,0,0,0,4.78,5.3,13.36,13.36,0,0,0,1.37,1c.48.31.94.65,1.42.93a24.76,24.76,0,0,0,3,1.45,23.67,23.67,0,0,0,3.06,1c.51.12,1,.19,1.55.28l.76.14c.26,0,.52,0,.77.06l1.53.1c.51,0,1,0,1.51-.06a20.21,20.21,0,0,0,2.93-.33,22.66,22.66,0,0,0,9.85-4.57,25.25,25.25,0,0,0,6.11-7.05,26.46,26.46,0,0,0,2.81-6.68,19.55,19.55,0,0,0,.59-2.61c.07-.39.15-.74.2-1.07l.1-.89a5.88,5.88,0,0,1,.28-1.63,5.09,5.09,0,0,1,.09,1.66c0,.27,0,.58,0,.91s-.07.7-.11,1.1a20.44,20.44,0,0,1-.45,2.72,25.49,25.49,0,0,1-2.62,7.06,25.75,25.75,0,0,1-6.21,7.6A23.7,23.7,0,0,1,194.26,238a21.3,21.3,0,0,1-3.12.42c-.53,0-1.07.08-1.61.08l-1.64-.08c-.27,0-.55,0-.82-.06l-.82-.13c-.55-.09-1.11-.16-1.67-.28a25.48,25.48,0,0,1-6.51-2.55c-.52-.3-1-.65-1.53-1a12.26,12.26,0,0,1-1.49-1.11,23,23,0,0,1-5.19-5.67,26.33,26.33,0,0,1-3.46-7.38,28.36,28.36,0,0,1,.22-16.91,26.93,26.93,0,0,1,3.65-7.36,30.21,30.21,0,0,1,2.48-3.09,29.89,29.89,0,0,1,2.86-2.57,14.53,14.53,0,0,1,1.51-1.1c.52-.33,1-.68,1.56-1a25.18,25.18,0,0,1,3.26-1.51,23.91,23.91,0,0,1,3.32-1c.55-.12,1.11-.18,1.67-.28l.82-.12a7.7,7.7,0,0,1,.83-.05l1.63-.08c.55,0,1.08.06,1.61.08a21,21,0,0,1,3.11.43,23.13,23.13,0,0,1,10.24,5.1,25.84,25.84,0,0,1,8.46,14.69,19.24,19.24,0,0,1,.37,2.72c0,.4.08.76.09,1.1s0,.64,0,.91A5.26,5.26,0,0,1,213.94,211.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.4,215.89a5.18,5.18,0,0,1-4.67,5.38,4.71,4.71,0,0,1-5-4.65,5.19,5.19,0,0,1,4.67-5.38A4.71,4.71,0,0,1,197.4,215.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.08,202.55c-.6.69-4.29-2.19-9.53-2.08s-9.06,3-9.63,2.31c-.28-.3.34-1.55,2-2.89a12.83,12.83,0,0,1,7.71-2.7,12.07,12.07,0,0,1,7.58,2.51C198.83,201,199.38,202.23,199.08,202.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.05,228.39c-.12.2-1.76-.62-3.74-2.87a21.19,21.19,0,0,1-4.83-10.79,22.31,22.31,0,0,1,1.6-11.95c1.26-2.83,2.58-4.18,2.76-4s-.68,1.77-1.55,4.54a25.6,25.6,0,0,0-1,11.11,24.35,24.35,0,0,0,4,10.21C175.92,226.94,177.23,228.14,177.05,228.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.46,232.39a.77.77,0,0,1-.65.6,2,2,0,0,1-1.41-.25,2.21,2.21,0,0,1-1-1.08.84.84,0,0,1,.07-.91c.4-.36,1.12-.14,1.79.21S183.5,231.84,183.46,232.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.79,281.66s9.6-25.44,11-26.76,15.57-13.22,15.57-13.22a7.51,7.51,0,0,1,4.36.6c1.39.81,4.77,6.15,6.12,8.34a2.63,2.63,0,0,1,.31,2l-1.54,5s1.85,2.91,1.41,5a14.2,14.2,0,0,1-1.52,3.92,8.22,8.22,0,0,1,.64,5.91,7.92,7.92,0,0,1-3.9,4.25S182.14,282,182,283s-5.36,3.38-5.9,3.23-4.34-1.77-4.34-1.77S170,293,167.8,294.93a11.25,11.25,0,0,1-5.08,2.34L160,310.88,143.13,298Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.05,274a34.18,34.18,0,0,1,4.59,1.45,45.88,45.88,0,0,1,4.52,1.66,22.12,22.12,0,0,1-4.64-1.28A26.94,26.94,0,0,1,174.05,274Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.18,263.38a8.58,8.58,0,0,1,1.89.26c1.16.23,2.75.59,4.48,1.06s3.29,1,4.4,1.39a8.61,8.61,0,0,1,1.76.75,11.14,11.14,0,0,1-1.84-.48c-1.13-.33-2.69-.79-4.42-1.27s-3.3-.88-4.43-1.17A9.43,9.43,0,0,1,174.18,263.38Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.35,255.11a8.86,8.86,0,0,1,2.1-.05,34.41,34.41,0,0,1,5,.56,36,36,0,0,1,4.9,1.26,8.86,8.86,0,0,1,1.95.8,13.53,13.53,0,0,1-2-.53c-1.24-.34-3-.78-4.9-1.14s-3.69-.55-5-.67A14.25,14.25,0,0,1,172.35,255.11Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.91,256.42a7.39,7.39,0,0,1-.41-3.73,3.8,3.8,0,0,1-3.09-1.11c-.89,1.12-2.08,2.67-3,3.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.16,277.76l4.94,58.55s9.08,58.71,8.41,62.86-8.81,24.39-8.81,24.39c35.14,14.21,87.84,19.76,134.76-1.31L310.61,395l13.2-121.91-47.75-16.31s-2.88,17.4-25.76,15.47-22.47-14.56-22.47-14.56l-40.59,11.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.67,396.88S335.48,274,322.58,273l-9.68,93.2,18.26,52C343.62,411.73,355.06,404.73,364.67,396.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.59,296.46c.15,0-1.13,14.83-2.86,33.09s-3.23,33.06-3.38,33.05,1.14-14.83,2.86-33.1S320.45,296.44,320.59,296.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.79,295.4a2.63,2.63,0,0,1,.11.65c.06.48.14,1.1.23,1.88.18,1.69.44,4,.75,6.9.62,5.84,1.45,13.9,2.47,22.78s2.08,16.93,2.92,22.73c.43,2.86.77,5.19,1,6.87l.27,1.87a2.73,2.73,0,0,1,.06.66,3.29,3.29,0,0,1-.16-.64c-.1-.48-.22-1.09-.37-1.85-.31-1.61-.71-3.95-1.18-6.85-.94-5.8-2-13.83-3.07-22.73s-1.8-17-2.33-22.8c-.24-2.88-.44-5.23-.58-6.93-.05-.77-.1-1.4-.13-1.88A2.55,2.55,0,0,1,183.79,295.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.56 260.64 227.23 253.18 251.81 273.04 275.84 249.59 283.5 259.28 254.41 290.45 222.56 260.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,274.77a8.24,8.24,0,0,1-.21,1.2c-.17.77-.43,1.9-.82,3.3a72.16,72.16,0,0,1-4.18,11.15l-.17.37-.24-.33c-2-2.7-4.12-5.67-6.43-8.78-4.5-6.07-8.67-11.49-11.71-15.41l-3.6-4.63-1-1.27c-.22-.3-.33-.46-.31-.47a2.59,2.59,0,0,1,.39.4l1,1.21c.89,1.06,2.17,2.61,3.73,4.54,3.11,3.85,7.33,9.25,11.84,15.32,2.31,3.11,4.47,6.09,6.4,8.81l-.41,0a80.49,80.49,0,0,0,4.33-11c.43-1.39.74-2.5,1-3.26A7.57,7.57,0,0,1,251,274.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.32,260.59a2,2,0,0,1-.22.44l-.7,1.21c-.63,1-1.56,2.53-2.79,4.33a116.33,116.33,0,0,1-10.56,13.3c-2.55,2.76-5.09,5.25-7.39,7.36l-.17.15-.16-.16a31.6,31.6,0,0,1-5.67-8c-.52-1.08-.88-2-1.1-2.56a5.63,5.63,0,0,1-.29-.95,4.63,4.63,0,0,1,.43.89c.26.59.66,1.44,1.21,2.49a33.15,33.15,0,0,0,5.76,7.84h-.33c2.28-2.12,4.79-4.62,7.32-7.37a134.79,134.79,0,0,0,10.65-13.15c1.26-1.77,2.24-3.22,2.92-4.23L282,261C282.2,260.71,282.3,260.58,282.32,260.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.11,433.29c-.14,0-.26-34.66-.26-77.4s.12-77.4.26-77.4.26,34.65.26,77.4S252.25,433.29,252.11,433.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.34,385.64c0,.14-10-2-22.24-4.83s-22.16-5.19-22.12-5.33,10,2,22.24,4.82S264.37,385.5,264.34,385.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.17,375.55c-.09-.06,1-1.27,2.16-3.51a23.81,23.81,0,0,0,1.71-4.11,24.59,24.59,0,0,0,.88-10.78,23.44,23.44,0,0,0-1-4.33c-.81-2.41-1.65-3.77-1.56-3.82a4,4,0,0,1,.62.93,8.68,8.68,0,0,1,.61,1.16,15,15,0,0,1,.68,1.61,22.13,22.13,0,0,1,1.15,4.38,25.76,25.76,0,0,1,.2,5.55,26.41,26.41,0,0,1-1.1,5.45,22.17,22.17,0,0,1-1.85,4.14,17.36,17.36,0,0,1-.93,1.47,9.91,9.91,0,0,1-.79,1C150.46,375.28,150.2,375.58,150.17,375.55Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Markets--inject-205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.27,232a46.81,46.81,0,1,0,44.31-44.32A46.81,46.81,0,0,0,380.27,232Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,234.32s0-.26,0-.76,0-1.28.07-2.23l.06-1.64c.06-.61.17-1.26.27-2a33.33,33.33,0,0,1,.91-4.87,44.42,44.42,0,0,1,5.12-12.55A47.12,47.12,0,0,1,418.07,188a43.13,43.13,0,0,1,6-.7c1,0,2-.14,3.07-.13l3.12.15c.53,0,1.06,0,1.58.1l1.57.24c1.05.17,2.12.29,3.18.51a49.92,49.92,0,0,1,6.29,1.83A48.31,48.31,0,0,1,449,192.7c1,.54,2,1.17,2.94,1.75a24,24,0,0,1,2.85,2,53.21,53.21,0,0,1,5.36,4.54,54.15,54.15,0,0,1,4.63,5.47,45.55,45.55,0,0,1,6.76,13,46.68,46.68,0,0,1,0,29.79,45.58,45.58,0,0,1-6.75,13,53,53,0,0,1-4.64,5.46,52.12,52.12,0,0,1-5.35,4.55,23.66,23.66,0,0,1-2.86,1.95c-1,.59-1.94,1.22-2.94,1.75a51.11,51.11,0,0,1-12.45,4.53c-1.06.22-2.13.34-3.18.51l-1.57.24c-.52.07-1.05.06-1.58.1l-3.12.15c-1,0-2.05-.09-3.07-.13a43.13,43.13,0,0,1-6-.71,47.12,47.12,0,0,1-31.69-22.28,44.7,44.7,0,0,1-5.11-12.56,33,33,0,0,1-.91-4.86c-.1-.71-.21-1.37-.27-2l-.06-1.64c0-1,0-1.7-.07-2.23s0-.76,0-.76,0,.26.08.76.09,1.27.15,2.22c0,.49.07,1,.1,1.63s.2,1.25.3,1.95a34.77,34.77,0,0,0,1,4.83,44.73,44.73,0,0,0,5.2,12.4A46.8,46.8,0,0,0,418.19,280a43.34,43.34,0,0,0,5.88.67c1,0,2,.14,3,.12l3.07-.16c.52,0,1,0,1.55-.1l1.55-.24c1-.17,2.09-.29,3.13-.51a48.45,48.45,0,0,0,6.19-1.82,49.1,49.1,0,0,0,6.06-2.66c1-.54,1.92-1.16,2.89-1.73a23.21,23.21,0,0,0,2.8-1.93,42.34,42.34,0,0,0,9.82-9.87A44.67,44.67,0,0,0,470.79,249a45.88,45.88,0,0,0,0-29.29,45.05,45.05,0,0,0-6.63-12.79,53.64,53.64,0,0,0-4.55-5.38,52.91,52.91,0,0,0-5.27-4.48,24,24,0,0,0-2.8-1.93c-1-.58-1.91-1.2-2.89-1.73a46.26,46.26,0,0,0-6.06-2.66,48.45,48.45,0,0,0-6.19-1.82c-1-.22-2.09-.34-3.12-.51l-1.55-.24c-.52-.07-1-.07-1.56-.1l-3.07-.16c-1,0-2,.08-3,.11a43.71,43.71,0,0,0-5.88.68,46.71,46.71,0,0,0-31.42,21.87,44.73,44.73,0,0,0-5.2,12.4,35,35,0,0,0-1,4.82c-.1.71-.23,1.36-.3,2s-.07,1.14-.1,1.63q-.09,1.42-.15,2.22C380,234.06,380,234.32,380,234.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.77,
    y: 219.69,
    width: 42.15,
    height: 35.94,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.92,255.63s0-.24,0-.68,0-1.11,0-1.93c0-1.71,0-4.18-.06-7.31,0-6.29-.06-15.24-.11-26l.22.22-42.14,0a3.45,3.45,0,0,1,.25-.26h0v9.61q0,4.73,0,9.26c0,6,0,11.75,0,17.06l-.23-.23,30.42.12,8.63.06,2.29,0h.81l-.18,0h-.57l-2.25,0-8.58.06-30.57.11h-.23v-.23c0-5.31,0-11,0-17.06q0-4.53,0-9.26V219.7h0c-.23.23.32-.32.27-.26l42.14,0h.22v.22c-.05,10.84-.09,19.84-.11,26.16,0,3.11,0,5.56-.06,7.26q0,1.21,0,1.89C449.94,255.43,449.92,255.63,449.92,255.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.13,232h-1.87a5.08,5.08,0,0,1-5.08-5.08v-8.34h12v8.34A5.08,5.08,0,0,1,412.13,232Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.13,232c0-.05.44,0,1.19-.23A5.13,5.13,0,0,0,416,230a5,5,0,0,0,.92-2.08,18.63,18.63,0,0,0,.07-2.74c0-2,0-4.19,0-6.55l.25.25h-12l.25-.25c0,2.6,0,5,0,7.24,0,.54,0,1.09,0,1.57a5.22,5.22,0,0,0,.34,1.4,4.9,4.9,0,0,0,1.53,2,5.32,5.32,0,0,0,3.48,1.09,8.25,8.25,0,0,1,1.37.09,8.25,8.25,0,0,1-1.37.09,5.38,5.38,0,0,1-3.68-1,5.24,5.24,0,0,1-1.69-2.14,5.32,5.32,0,0,1-.39-1.51c-.05-.54,0-1.06,0-1.61,0-2.21,0-4.64,0-7.24v-.25h12.54v.25c0,2.36,0,4.56,0,6.55a18.42,18.42,0,0,1-.12,2.81,5.25,5.25,0,0,1-1.05,2.2,5,5,0,0,1-2.89,1.79,4.72,4.72,0,0,1-.91.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.07,232h-1.88a5.09,5.09,0,0,1-5.08-5.08v-8.34h12v8.34A5.09,5.09,0,0,1,424.07,232Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.07,232c0-.05.43,0,1.18-.23a5.09,5.09,0,0,0,2.69-1.82,5.15,5.15,0,0,0,.93-2.08,20.13,20.13,0,0,0,.07-2.74c0-2,0-4.19,0-6.55l.25.25h-12l.26-.25c0,2.6,0,5,0,7.24,0,.54,0,1.09,0,1.57a5.21,5.21,0,0,0,.33,1.4,5.08,5.08,0,0,0,1.53,2,5.35,5.35,0,0,0,3.48,1.09,8.47,8.47,0,0,1,1.38.09,8.47,8.47,0,0,1-1.38.09,5.4,5.4,0,0,1-3.68-1,5.24,5.24,0,0,1-1.69-2.14,6.09,6.09,0,0,1-.39-1.51c0-.54,0-1.06,0-1.61,0-2.21,0-4.64,0-7.24v-.25H429.4v.25c0,2.36,0,4.56,0,6.55a17.2,17.2,0,0,1-.13,2.81,5.24,5.24,0,0,1-1,2.2,5,5,0,0,1-2.9,1.79,4.57,4.57,0,0,1-.91.1A1.2,1.2,0,0,1,424.07,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,232h-1.87a5.08,5.08,0,0,1-5.08-5.08v-8.34h12v8.34A5.08,5.08,0,0,1,436,232Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,232c0-.05.43,0,1.19-.23a5.13,5.13,0,0,0,2.69-1.82,5,5,0,0,0,.92-2.08,18.63,18.63,0,0,0,.07-2.74c0-2,0-4.19,0-6.55l.25.25h-12l.25-.25c0,2.6,0,5,0,7.24,0,.54,0,1.09,0,1.57a5.21,5.21,0,0,0,.33,1.4,5,5,0,0,0,1.54,2,5.31,5.31,0,0,0,3.47,1.09A8.32,8.32,0,0,1,436,232a8.32,8.32,0,0,1-1.38.09,5.28,5.28,0,0,1-5.37-3.15,5.67,5.67,0,0,1-.38-1.51c-.05-.54,0-1.06,0-1.61,0-2.21,0-4.64,0-7.24v-.25h12.54v.25c0,2.36,0,4.56,0,6.55a18.42,18.42,0,0,1-.12,2.81,5.25,5.25,0,0,1-1.05,2.2,5,5,0,0,1-2.89,1.79,4.72,4.72,0,0,1-.91.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.94,232h-1.88a5.09,5.09,0,0,1-5.08-5.08v-8.34h12v8.34A5.09,5.09,0,0,1,447.94,232Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.94,232c0-.05.43,0,1.18-.23a5,5,0,0,0,3.62-3.9,18.71,18.71,0,0,0,.06-2.74c0-2,0-4.19,0-6.55l.25.25H441l.26-.25c0,2.6,0,5,0,7.24,0,.54,0,1.09,0,1.57a5.63,5.63,0,0,0,.34,1.4,5.08,5.08,0,0,0,1.53,2,5.34,5.34,0,0,0,3.48,1.09,8.47,8.47,0,0,1,1.38.09,8.47,8.47,0,0,1-1.38.09,5.4,5.4,0,0,1-3.68-1,5.24,5.24,0,0,1-1.69-2.14,5.68,5.68,0,0,1-.39-1.51c0-.54,0-1.06,0-1.61,0-2.21,0-4.64,0-7.24v-.25h12.54v.25c0,2.36,0,4.56,0,6.55a18.39,18.39,0,0,1-.13,2.81,5.13,5.13,0,0,1-1.05,2.2,5,5,0,0,1-2.89,1.79,4.57,4.57,0,0,1-.91.1A1.2,1.2,0,0,1,447.94,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.07,
    y: 236.56,
    width: 11.76,
    height: 19.08,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.83,236.56a11,11,0,0,1,.06,1.35c0,1,0,2.28.07,3.91,0,3.45.07,8.23.12,13.81v.24h-.25l-11.75,0c.05.06-.5-.49-.27-.26h0v-1.33c0-.44,0-.89,0-1.33v-2.62c0-1.73,0-3.4,0-5,0-3.21,0-6.16,0-8.76v-.21h.21l8.64.11,2.33,0a4.19,4.19,0,0,1,.78.05,7.68,7.68,0,0,1-.86,0l-2.38.05-8.51.11.2-.2c0,2.6,0,5.55,0,8.76,0,1.61,0,3.28,0,5V253c0,.44,0,.89,0,1.33v1.33h0l-.26-.26,11.75,0-.24.24c.05-5.52.09-10.24.12-13.66,0-1.64.05-3,.07-4,0-.42,0-.77,0-1.07S444.83,236.57,444.83,236.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.36,
    y: 235.71,
    width: 10.53,
    height: 12.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.89,248.68a7,7,0,0,1-.06-1c0-.69,0-1.59-.06-2.68,0-2.28-.1-5.49-.12-9.3l.23.23-10.52,0,.26-.26h0v1.77c0,.59,0,1.17,0,1.75v3.36c0,2.18,0,4.22,0,6.08l-.21-.22,7.57.12,2.16,0a5.72,5.72,0,0,1,.8.05,3.62,3.62,0,0,1-.71,0l-2.11.06c-1.83,0-4.49.08-7.71.11h-.22v-.22c0-1.86,0-3.9,0-6.08,0-1.09,0-2.21,0-3.36v-3.52h0c-.24.23.31-.32.26-.26l10.52,0h.24v.23c0,3.91-.08,7.18-.12,9.45,0,1.07,0,2-.06,2.63A7.79,7.79,0,0,1,424.89,248.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 441.44,
    y: 243.49,
    width: 1.75,
    height: 5.2,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Customers--inject-205"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141.72,
    cy: 121.48,
    r: 46.81,
    transform: "translate(-14.04 18.61) rotate(-7.16)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.91,121.48s0-.25,0-.76,0-1.26.08-2.22c0-.5,0-1,.07-1.65s.18-1.25.27-2,.22-1.48.34-2.29a26,26,0,0,1,.59-2.57A44.68,44.68,0,0,1,101.4,97.5a46.68,46.68,0,0,1,11.88-13.37l2-1.52c.71-.47,1.46-.91,2.2-1.37s1.48-1,2.29-1.33l2.44-1.18,1.24-.59,1.3-.48,2.65-1c.89-.3,1.83-.5,2.76-.75a22.65,22.65,0,0,1,2.85-.65,42.84,42.84,0,0,1,5.94-.7c1,0,2-.14,3.07-.13l3.11.16c.52,0,1.05,0,1.57.09l1.57.24c1,.17,2.11.29,3.17.51a49.16,49.16,0,0,1,6.27,1.83l1.57.57.78.29.75.37,3,1.46c1,.54,1.94,1.16,2.93,1.75.48.3,1,.57,1.45.91l1.39,1A52.89,52.89,0,0,1,175,88.21l2.4,2.63.6.67.54.71,1.08,1.44,1.08,1.45,1,1.55.95,1.55.47.79c.15.27.27.55.41.82.53,1.1,1.06,2.21,1.6,3.32s.85,2.32,1.28,3.48a50.59,50.59,0,0,1,2.43,14.86,50.2,50.2,0,0,1-2.43,14.85c-.43,1.17-.85,2.33-1.28,3.49s-1.07,2.22-1.6,3.32l-.4.82-.48.78-.94,1.56-.95,1.55-1.09,1.45-1.08,1.44-.54.72-.6.66L175,154.75a53,53,0,0,1-5.35,4.53l-1.38,1c-.46.35-1,.61-1.46.92-1,.58-1.94,1.21-2.93,1.75l-3,1.46-.75.36c-.26.11-.52.2-.78.29l-1.57.57a49.64,49.64,0,0,1-6.27,1.83c-1.06.22-2.12.34-3.17.51l-1.57.24c-.52.07-1,.06-1.57.1l-3.11.15c-1,0-2.06-.08-3.07-.12a44.23,44.23,0,0,1-5.94-.7,24.57,24.57,0,0,1-2.85-.66c-.93-.25-1.87-.44-2.77-.75l-2.64-1-1.3-.48-1.24-.59-2.44-1.18c-.81-.37-1.53-.9-2.29-1.33s-1.49-.89-2.2-1.36l-2-1.52a46.56,46.56,0,0,1-11.88-13.38,44.63,44.63,0,0,1-5.13-12.52c-.2-.91-.5-1.75-.59-2.57s-.23-1.58-.34-2.29-.21-1.37-.27-2,0-1.15-.07-1.64c0-1-.06-1.71-.08-2.23s0-.76,0-.76,0,.26.06.76.08,1.26.14,2.22c0,.49.06,1,.09,1.64s.19,1.25.3,2,.23,1.47.36,2.28a24.07,24.07,0,0,0,.61,2.56,44.52,44.52,0,0,0,5.18,12.42,46.46,46.46,0,0,0,11.85,13.23l2,1.51c.71.46,1.45.89,2.19,1.34s1.47,1,2.27,1.32l2.42,1.16,1.23.58,1.3.47,2.62,1c.89.29,1.82.48,2.74.73a24.49,24.49,0,0,0,2.82.64,42.26,42.26,0,0,0,5.9.68c1,0,2,.14,3,.12l3.09-.16c.51,0,1,0,1.55-.1l1.56-.24c1-.17,2.09-.29,3.13-.5a48.32,48.32,0,0,0,6.21-1.83l1.55-.56.77-.29.75-.36,3-1.46c1-.53,1.92-1.15,2.9-1.73.47-.3,1-.56,1.44-.91l1.37-1a53.13,53.13,0,0,0,5.28-4.49q1.17-1.31,2.37-2.61l.59-.66.54-.71,1.06-1.42,1.07-1.44.94-1.53.94-1.54.47-.77.39-.82,1.59-3.28,1.26-3.45a49.82,49.82,0,0,0,2.4-14.69,50,50,0,0,0-2.4-14.69l-1.27-3.45c-.53-1.1-1-2.19-1.58-3.28-.13-.27-.26-.55-.4-.82l-.47-.77-.93-1.54-.94-1.53L179.21,94l-1.07-1.42-.53-.71-.6-.66-2.36-2.6a51.93,51.93,0,0,0-5.29-4.49l-1.37-1c-.45-.34-1-.6-1.44-.91-1-.58-1.91-1.2-2.9-1.73l-3-1.45-.75-.36c-.25-.11-.52-.19-.77-.29l-1.55-.57a49.91,49.91,0,0,0-6.21-1.82c-1-.22-2.1-.34-3.13-.51l-1.56-.24c-.51-.07-1-.06-1.55-.1l-3.08-.16c-1,0-2,.09-3,.12a43.49,43.49,0,0,0-5.89.68,24,24,0,0,0-2.82.64c-.92.25-1.86.44-2.75.74l-2.62,1-1.29.47-1.23.59L120,80.26c-.81.36-1.52.89-2.28,1.31s-1.48.88-2.19,1.35l-2,1.5a46.5,46.5,0,0,0-11.86,13.23,44.45,44.45,0,0,0-5.18,12.43,23.36,23.36,0,0,0-.61,2.55q-.19,1.22-.36,2.28c-.11.71-.23,1.36-.3,2s-.06,1.14-.09,1.63L95,120.72C94.94,121.23,94.91,121.48,94.91,121.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,123.53a8.68,8.68,0,0,0,5.17-8,8.16,8.16,0,1,0-16.29-.07,8.7,8.7,0,0,0,5.19,8.11c-12.53,1.89-12,15.51-12,15.51l29.64.14S157.39,125.4,145,123.53Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.35,114.28a5.42,5.42,0,0,0,3.24-5,5.11,5.11,0,1,0-10.2,0,5.41,5.41,0,0,0,3.25,5.07c-7.85,1.19-7.5,9.72-7.5,9.72l18.57.08S171.13,115.46,163.35,114.28Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.93,114.28a5.42,5.42,0,0,0,3.24-5,5.11,5.11,0,1,0-10.2,0,5.41,5.41,0,0,0,3.25,5.07c-7.85,1.19-7.49,9.72-7.49,9.72l18.56.08S131.71,115.46,123.93,114.28Z",
    style: {
      fill: "#D14343"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Products--inject-205"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 325.95,
    cy: 90.73,
    r: 46.81,
    transform: "translate(161.33 386.33) rotate(-76.44)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.14,90.73s0-.25,0-.76.05-1.27.08-2.23c0-.49,0-1,.06-1.64s.17-1.26.27-2a33,33,0,0,1,.91-4.86,44.4,44.4,0,0,1,5.11-12.56,47.12,47.12,0,0,1,31.69-22.28,43.13,43.13,0,0,1,6-.71c1,0,2-.14,3.07-.13l3.12.16c.52,0,1.05,0,1.58.09l1.57.24c1.05.17,2.12.29,3.17.51a51,51,0,0,1,12.46,4.53c1,.53,1.95,1.16,2.94,1.75a24.76,24.76,0,0,1,2.85,2,53.32,53.32,0,0,1,5.36,4.55A53,53,0,0,1,364,62.83a45.8,45.8,0,0,1,6.76,13,50.48,50.48,0,0,1,2.44,14.9,50.47,50.47,0,0,1-2.44,14.89,45.61,45.61,0,0,1-6.76,13,54.15,54.15,0,0,1-4.63,5.47,53.21,53.21,0,0,1-5.36,4.54,24,24,0,0,1-2.85,2c-1,.58-1.94,1.21-2.94,1.75A48.31,48.31,0,0,1,342,135a49.64,49.64,0,0,1-6.3,1.84c-1.05.21-2.12.33-3.17.5l-1.57.24c-.53.07-1.06.07-1.58.1l-3.12.15c-1,0-2.06-.09-3.07-.12a44.33,44.33,0,0,1-6-.71,47.11,47.11,0,0,1-31.69-22.29,44.47,44.47,0,0,1-5.11-12.55,33.33,33.33,0,0,1-.91-4.87c-.1-.71-.22-1.36-.27-2s0-1.15-.06-1.64c0-1-.06-1.69-.08-2.23s0-.76,0-.76,0,.26.08.76.08,1.27.15,2.22c0,.49.06,1,.1,1.64s.19,1.24.3,2a33.52,33.52,0,0,0,1,4.82,44.67,44.67,0,0,0,5.19,12.4,46.7,46.7,0,0,0,31.43,21.87,43.38,43.38,0,0,0,5.87.68c1,0,2,.13,3,.11l3.08-.16c.51,0,1,0,1.55-.1l1.55-.24c1-.17,2.09-.29,3.13-.51a46.89,46.89,0,0,0,6.19-1.82,47.46,47.46,0,0,0,6.06-2.66c1-.53,1.92-1.15,2.89-1.73a24,24,0,0,0,2.8-1.93,52.91,52.91,0,0,0,5.27-4.48,53.64,53.64,0,0,0,4.55-5.38A45.05,45.05,0,0,0,370,105.38a49.6,49.6,0,0,0,2.39-14.65A49.49,49.49,0,0,0,370,76.08a44.83,44.83,0,0,0-6.64-12.79,51.12,51.12,0,0,0-4.55-5.38,51.69,51.69,0,0,0-5.26-4.48,24,24,0,0,0-2.8-1.93c-1-.57-1.91-1.19-2.89-1.73a51.23,51.23,0,0,0-12.25-4.48c-1-.21-2.09-.34-3.13-.51l-1.55-.24c-.51-.07-1-.06-1.55-.1l-3.07-.16c-1,0-2,.08-3,.12a43.34,43.34,0,0,0-5.88.67,46.11,46.11,0,0,0-19.57,8.68,46.69,46.69,0,0,0-11.86,13.19,44.67,44.67,0,0,0-5.19,12.4,33.36,33.36,0,0,0-1,4.83c-.11.7-.24,1.35-.3,2s-.07,1.14-.1,1.63c-.07,1-.12,1.69-.15,2.23S279.14,90.73,279.14,90.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.62,
    y: 72.09,
    width: 31.55,
    height: 36.36,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 314.62,
    y: 72.09,
    width: 31.55,
    height: 36.36
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 299.93,
    y: 72.09,
    width: 27.15,
    height: 36.36,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.17,108.44a3.29,3.29,0,0,1-.41-.65l-1.09-1.94-3.93-7.16L328,75c-.39-.72-.77-1.43-1.12-2.1l.49-.12c0,10-.06,18.86-.08,25.35,0,3.17-.07,5.75-.09,7.6,0,.85,0,1.54,0,2a5.86,5.86,0,0,1-.05.72,3.13,3.13,0,0,1-.05-.72c0-.51,0-1.2,0-2,0-1.85-.05-4.43-.08-7.6,0-6.49,0-15.4-.08-25.35a.26.26,0,0,1,.26-.26.29.29,0,0,1,.23.14l1.12,2.09,12.64,23.78c1.57,3,2.86,5.48,3.78,7.24.42.82.75,1.48,1,2A3.69,3.69,0,0,1,346.17,108.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.17,72.09a10.52,10.52,0,0,1-.65,1.49c-.44.94-1.11,2.29-1.95,4-1.68,3.33-4.09,7.89-6.84,12.88s-5.27,9.49-7.11,12.73l-2.2,3.83a11,11,0,0,1-.87,1.38,10.29,10.29,0,0,1,.69-1.47L329.3,103c1.76-3.29,4.24-7.81,7-12.8l7-12.8c.86-1.58,1.56-2.89,2.1-3.89A10.37,10.37,0,0,1,346.17,72.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.58,
    y: 96.84,
    width: 6.79,
    height: 7.82,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Technologies--inject-205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.36,390.28A46.81,46.81,0,1,0,387.68,346,46.82,46.82,0,0,0,343.36,390.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.3,392.71s0-.25,0-.76,0-1.27.07-2.23c0-.49,0-1,.07-1.64s.17-1.26.26-2a31.84,31.84,0,0,1,.92-4.86,44.11,44.11,0,0,1,5.11-12.56,47.07,47.07,0,0,1,31.68-22.28,43.13,43.13,0,0,1,6-.71c1,0,2-.14,3.08-.13l3.12.16c.52,0,1.05,0,1.57.09l1.58.24c1,.17,2.11.29,3.17.51a49.92,49.92,0,0,1,6.29,1.83,49.19,49.19,0,0,1,6.16,2.7c1,.53,2,1.16,2.94,1.75a23.92,23.92,0,0,1,2.85,1.95,52.23,52.23,0,0,1,5.36,4.55,53,53,0,0,1,4.63,5.46,45.55,45.55,0,0,1,6.76,13,46.77,46.77,0,0,1,0,29.79,45.86,45.86,0,0,1-6.76,13,54.15,54.15,0,0,1-4.63,5.47,53.21,53.21,0,0,1-5.36,4.54,25.75,25.75,0,0,1-2.85,2c-1,.58-2,1.21-3,1.75a47.7,47.7,0,0,1-6.16,2.69,50,50,0,0,1-6.29,1.84c-1.06.21-2.13.33-3.18.5l-1.57.24c-.52.07-1.05.07-1.58.1l-3.12.15c-1,0-2.05-.09-3.07-.12a44.72,44.72,0,0,1-6-.71,47.12,47.12,0,0,1-31.68-22.29,44.06,44.06,0,0,1-5.11-12.55,32.18,32.18,0,0,1-.92-4.87c-.09-.71-.21-1.36-.26-2s-.05-1.15-.07-1.64c0-.95-.05-1.69-.07-2.23s0-.76,0-.76,0,.26.08.76.09,1.27.15,2.22c0,.49.07,1,.1,1.64s.2,1.24.3,1.95a33.67,33.67,0,0,0,1,4.82,44.37,44.37,0,0,0,5.19,12.4,46.71,46.71,0,0,0,31.42,21.87,43.53,43.53,0,0,0,5.88.68c1,0,2,.13,3,.11l3.07-.16c.52,0,1,0,1.56-.1l1.55-.24c1-.17,2.08-.29,3.12-.51A51.23,51.23,0,0,0,412,433.67c1-.53,1.92-1.15,2.89-1.73a24.14,24.14,0,0,0,2.81-1.93,42.78,42.78,0,0,0,9.81-9.86,45.08,45.08,0,0,0,6.64-12.79,46,46,0,0,0,0-29.3,45.05,45.05,0,0,0-6.63-12.79,53.64,53.64,0,0,0-4.55-5.38,52.91,52.91,0,0,0-5.27-4.48,23.21,23.21,0,0,0-2.8-1.93c-1-.57-1.91-1.19-2.89-1.73a49.1,49.1,0,0,0-6.06-2.66,49.62,49.62,0,0,0-6.19-1.82c-1-.21-2.09-.34-3.12-.51l-1.55-.24c-.52-.07-1-.06-1.55-.1l-3.08-.16c-1,0-2,.08-3,.12a43.71,43.71,0,0,0-5.88.67,46.8,46.8,0,0,0-31.42,21.87,44.37,44.37,0,0,0-5.19,12.4,33.78,33.78,0,0,0-1,4.83c-.1.7-.23,1.35-.3,2s-.07,1.14-.1,1.63c-.06.95-.11,1.69-.15,2.23S343.3,392.71,343.3,392.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.65,377a18.34,18.34,0,0,1,4.44-1.93l.92-4.4,7.43-.13,1.07,4.36a18.34,18.34,0,0,1,4.51,1.78l3.76-2.46,5.34,5.16-2.32,3.84a18.17,18.17,0,0,1,1.93,4.44l4.39.92.14,7.43-4.37,1.07a18.08,18.08,0,0,1-1.77,4.51l2.46,3.76-5.16,5.34-3.84-2.33a18.27,18.27,0,0,1-4.45,1.94l-.91,4.39-7.43.13-1.07-4.36a17.93,17.93,0,0,1-4.51-1.77l-3.76,2.46L372.1,406l2.33-3.84a18.24,18.24,0,0,1-1.93-4.45l-4.4-.91-.13-7.43,4.37-1.07a17.93,17.93,0,0,1,1.77-4.51l-2.46-3.76,5.16-5.35,3.84,2.33Zm4,9.9a8,8,0,1,0,11.28-.2A8,8,0,0,0,384.61,386.93Z",
    style: {
      fill: "#D14343"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Prices--inject-205"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.39,433.54a46.81,46.81,0,1,0,44.31-44.31A46.82,46.82,0,0,0,134.39,433.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.33,436s0-.26,0-.76.05-1.28.08-2.23c0-.5,0-1,.06-1.65s.17-1.25.27-2a32.85,32.85,0,0,1,.91-4.87A44.24,44.24,0,0,1,140.75,412a47.09,47.09,0,0,1,31.69-22.29,44.72,44.72,0,0,1,6-.71c1,0,2-.14,3.07-.12l3.12.15c.52,0,1,0,1.58.1l1.57.23c1,.18,2.12.3,3.17.51a52.1,52.1,0,0,1,12.46,4.53c1,.54,1.95,1.17,2.94,1.75a23.64,23.64,0,0,1,2.85,2,42.89,42.89,0,0,1,10,10,45.67,45.67,0,0,1,6.76,13,46.68,46.68,0,0,1,0,29.79,45.55,45.55,0,0,1-6.76,13,42.89,42.89,0,0,1-10,10,22.87,22.87,0,0,1-2.85,2c-1,.59-1.94,1.21-2.94,1.75a51,51,0,0,1-12.46,4.53c-1,.21-2.12.34-3.17.51l-1.57.23c-.53.07-1.06.07-1.58.1l-3.12.16c-1,0-2.06-.09-3.07-.13a44.33,44.33,0,0,1-6-.71A47,47,0,0,1,140.75,460a44.24,44.24,0,0,1-5.11-12.55,32.85,32.85,0,0,1-.91-4.87c-.1-.71-.22-1.36-.27-2s0-1.15-.06-1.65c0-.95-.06-1.69-.08-2.23s0-.75,0-.75,0,.25.08.75.08,1.27.15,2.22c0,.49.06,1,.1,1.64s.19,1.25.3,2a33.63,33.63,0,0,0,1,4.83,44.62,44.62,0,0,0,5.19,12.39,46.7,46.7,0,0,0,31.43,21.87,41.83,41.83,0,0,0,5.87.68c1,0,2,.13,3,.12l3.08-.16c.51,0,1,0,1.55-.1l1.55-.24c1-.18,2.09-.3,3.13-.51A50.13,50.13,0,0,0,197,479.6a49,49,0,0,0,6.06-2.67c1-.53,1.92-1.15,2.89-1.72a24.11,24.11,0,0,0,2.8-1.94,50.37,50.37,0,0,0,5.27-4.48,52.54,52.54,0,0,0,4.55-5.38,45.05,45.05,0,0,0,6.63-12.79,46.1,46.1,0,0,0,0-29.3,44.77,44.77,0,0,0-6.64-12.78,42.26,42.26,0,0,0-9.81-9.86,22.85,22.85,0,0,0-2.8-1.93c-1-.58-1.91-1.2-2.89-1.73a49,49,0,0,0-6.06-2.67,50.13,50.13,0,0,0-6.19-1.82c-1-.21-2.09-.33-3.13-.5l-1.55-.24c-.51-.07-1-.07-1.55-.1l-3.07-.16c-1,0-2,.08-3,.11a43.34,43.34,0,0,0-5.88.68A46.1,46.1,0,0,0,153,399a46.69,46.69,0,0,0-11.86,13.19,44.79,44.79,0,0,0-5.19,12.4,33.63,33.63,0,0,0-1,4.83c-.11.7-.24,1.35-.3,1.95s-.07,1.15-.1,1.64c-.07.95-.12,1.68-.15,2.22S134.33,436,134.33,436Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.33,455.9v5.78h-6.25v-5.57c-5.2-.36-10.15-1.87-13.16-3.95l3.38-7.6a23,23,0,0,0,12,3.59c4.27,0,5.94-1.2,5.94-3,0-5.77-20.72-1.56-20.72-15.09,0-5.73,4.11-10.57,12.54-11.61v-5.72h6.25v5.62a25.3,25.3,0,0,1,10.57,3.07l-3.18,7.65a21.57,21.57,0,0,0-10.1-2.81c-4.32,0-5.88,1.46-5.88,3.28,0,5.57,20.66,1.4,20.66,14.83C196.4,449.92,192.45,454.71,184.33,455.9Z",
    style: {
      fill: "#D14343"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Competitors--inject-205"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70.97,
    cy: 269.27,
    r: 46.81,
    transform: "translate(-203.85 224.42) rotate(-65.97)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.78,269.27s0-.26-.06-.76-.08-1.26-.14-2.22c0-.49-.06-1-.09-1.64s-.19-1.25-.3-2l-.36-2.28a25.93,25.93,0,0,0-.61-2.55A44.57,44.57,0,0,0,111,245.43,46.64,46.64,0,0,0,99.18,232.2l-2-1.5c-.71-.46-1.46-.89-2.19-1.34s-1.47-1-2.28-1.32l-2.42-1.16-1.23-.58-1.29-.47-2.62-1c-.89-.3-1.83-.48-2.75-.74a22.14,22.14,0,0,0-2.82-.63,42,42,0,0,0-5.89-.69c-1,0-2-.13-3-.11l-3.08.15c-.52,0-1,0-1.56.11l-1.55.23c-1,.18-2.09.3-3.13.51a49.91,49.91,0,0,0-6.21,1.82l-1.55.57-.77.29-.75.36-3,1.45c-1,.54-1.92,1.16-2.9,1.74-.47.3-1,.56-1.43.9l-1.38,1A52.93,52.93,0,0,0,38,236.35L35.68,239l-.6.65-.53.71-1.07,1.43-1.07,1.43-.94,1.53-.93,1.54-.47.78c-.15.26-.27.54-.4.81-.53,1.09-1.05,2.18-1.58,3.28s-.84,2.3-1.27,3.45a46.16,46.16,0,0,0,0,29.38l1.26,3.45c.53,1.1,1.06,2.19,1.58,3.28l.4.82.47.77.94,1.54.94,1.54,1.07,1.43,1.06,1.43.54.71.59.65c.8.87,1.58,1.74,2.37,2.61a53.13,53.13,0,0,0,5.28,4.49l1.37,1c.46.35,1,.61,1.44.91,1,.58,1.92,1.2,2.9,1.74l3,1.45.75.36c.25.11.52.19.77.29l1.55.57a49.91,49.91,0,0,0,6.21,1.82c1,.21,2.1.33,3.13.51l1.56.24c.51.06,1,.06,1.55.1l3.09.15c1,0,2-.08,3-.11a42,42,0,0,0,5.89-.69,21.76,21.76,0,0,0,2.82-.63c.93-.26,1.86-.44,2.75-.74l2.62-1,1.3-.47,1.23-.58,2.42-1.16c.8-.37,1.52-.89,2.27-1.32s1.48-.88,2.19-1.34l2-1.5A46.64,46.64,0,0,0,111,293.09a44.4,44.4,0,0,0,5.18-12.42c.21-.9.51-1.74.61-2.55l.36-2.28c.11-.71.23-1.36.3-2s.06-1.15.09-1.64l.14-2.22c0-.5.06-.75.06-.75s0,.25,0,.75,0,1.26-.08,2.23c0,.49,0,1-.07,1.64s-.18,1.26-.28,2-.21,1.47-.33,2.29-.39,1.66-.59,2.57a44.51,44.51,0,0,1-5.13,12.52,46.71,46.71,0,0,1-11.88,13.38l-2,1.52c-.71.47-1.46.9-2.2,1.36s-1.48,1-2.29,1.34L90.45,312l-1.24.6-1.3.48-2.64,1c-.9.3-1.84.49-2.77.75a24.55,24.55,0,0,1-2.85.65,42.84,42.84,0,0,1-5.94.7c-1,0-2,.14-3.07.13l-3.11-.16c-.52,0-1,0-1.57-.1l-1.57-.23c-1-.18-2.11-.3-3.17-.51a49.78,49.78,0,0,1-6.28-1.83l-1.56-.57-.78-.3-.76-.36-3-1.46c-1-.54-1.95-1.17-2.93-1.75-.48-.31-1-.57-1.46-.92l-1.38-1a51.83,51.83,0,0,1-5.35-4.54l-2.39-2.63-.6-.66-.55-.72-1.07-1.44L32,295.63,31,294.09l-.94-1.56-.48-.78-.4-.83c-.53-1.1-1.07-2.21-1.6-3.32s-.85-2.32-1.28-3.49a46.59,46.59,0,0,1,0-29.7c.43-1.17.86-2.33,1.28-3.49s1.07-2.22,1.6-3.32c.14-.27.26-.55.4-.82l.48-.78.95-1.56.95-1.55,1.08-1.45L34.15,240l.54-.71.6-.66,2.4-2.64A51.81,51.81,0,0,1,43,231.46l1.39-1c.45-.35,1-.61,1.45-.92,1-.58,1.94-1.21,2.93-1.75l3.05-1.46.75-.36.78-.3,1.56-.57a49.78,49.78,0,0,1,6.28-1.83c1.05-.21,2.12-.33,3.17-.51L66,222.5c.52-.07,1.05-.07,1.57-.1l3.11-.16c1,0,2,.09,3.07.13a44.42,44.42,0,0,1,5.94.7,24.55,24.55,0,0,1,2.85.65c.93.26,1.87.45,2.76.75l2.65,1,1.3.48,1.24.59,2.44,1.18A25.71,25.71,0,0,1,95.17,229c.75.46,1.5.89,2.21,1.36l2,1.52a46.58,46.58,0,0,1,11.88,13.38,44.51,44.51,0,0,1,5.13,12.52c.2.91.5,1.75.59,2.57s.23,1.58.33,2.29.22,1.36.28,2,0,1.15.07,1.64c0,1,.06,1.71.08,2.23S117.78,269.27,117.78,269.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5,250.4a6.77,6.77,0,1,1-6.77-6.77A6.77,6.77,0,0,1,79.5,250.4Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.73,
    cy: 241.87,
    r: 1.76,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.75,292.38H83.87a3.29,3.29,0,0,1,3.29,3.29v1.66a0,0,0,0,1,0,0H58.46a0,0,0,0,1,0,0v-1.66A3.29,3.29,0,0,1,61.75,292.38Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.59 292.47 64.3 294.86 81.63 294.86 83.46 292.47 62.59 292.47",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.9,
    y: 270.12,
    width: 13.66,
    height: 3.17,
    rx: 1.49,
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.42,270.55s-.18,15.23-5.83,21.92H73.05V270.55Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.36,270.55s.45,15.23,6.1,21.92H72.73V270.55Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.79,249.13c-2.19-2.08-4.11.15-4.9,1s-2.4.63-3.27-.84c-.72-1.22-1.55-1.24-1.89-1.2s-1.17,0-1.89,1.2c-.87,1.47-2.48,1.66-3.27.84s-2.71-3-4.91-1c0,0,4.55,5.74,5.25,11.68s.63,8.73,0,10.38h9.64c-.63-1.65-.7-4.44,0-10.38S82.79,249.13,82.79,249.13Z",
    style: {
      fill: "#D14343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.64,292.47c0,.14-4.76.26-10.64.26s-10.63-.12-10.63-.26,4.76-.26,10.63-.26S83.64,292.32,83.64,292.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.86,273.26a27.13,27.13,0,0,1-5.26.26,27.13,27.13,0,0,1-5.26-.26A27.13,27.13,0,0,1,72.6,273,27.13,27.13,0,0,1,77.86,273.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.91,270.71A34.35,34.35,0,0,1,73,271a34.18,34.18,0,0,1-5.91-.26,34.18,34.18,0,0,1,5.91-.26A34.35,34.35,0,0,1,78.91,270.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25,248.36a4.4,4.4,0,0,0-.81,0,4.68,4.68,0,0,0-2,1,5.82,5.82,0,0,1-1.42.82,2,2,0,0,1-1.94-.22,14.84,14.84,0,0,1-1.41-1.47,1.31,1.31,0,0,0-1.68-.19,8.05,8.05,0,0,0-1.53,1.41,2.46,2.46,0,0,1-2,.89,3.29,3.29,0,0,1-1.69-.91,4.31,4.31,0,0,0-1.27-.83,3.23,3.23,0,0,0-2.15,0c-.5.16-.74.35-.77.31s.18-.27.7-.5a3.23,3.23,0,0,1,2.34-.12,4.83,4.83,0,0,1,1.42.84,3,3,0,0,0,1.47.78,2,2,0,0,0,1.55-.78,8.26,8.26,0,0,1,1.63-1.51,1.94,1.94,0,0,1,1.21-.27,1.9,1.9,0,0,1,1.07.55c.55.52.88,1.11,1.35,1.45a1.57,1.57,0,0,0,1.52.2,5.77,5.77,0,0,0,1.35-.71,4.23,4.23,0,0,1,2.15-.91C81,248.12,81.27,248.35,81.25,248.36Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitive);
export default __webpack_public_path__ + "static/media/Competitive.e9d5bc9fb6bde42507aae24d219ee4ba.svg";
export { ForwardRef as ReactComponent };